export const environment = {
  production: true,
  buildId: '2956548272019791',
  configFile: 'config.json',
};
